/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwareCodeClassicRoute } from '@jira/router-routes__classic-projects-routes/src/softwareCodeClassicRoute.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import {
	GSNSoftwareCodeClassicPageEntrypoint,
	softwareCodeClassicPageEntrypoint,
} from './ui/software/code/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareCodeClassicRouteEntry: Route = createEntry(softwareCodeClassicRoute, () => ({
	group: 'classic-software',
	resources: [
		...getNavigationResources({ isUsingSidebarEntrypoint: true }),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],
	layout: classicSoftwareProjectLayout,
	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
		sidebarId: SidebarIdContent,
	},
	entryPoint: () => {
		if (isDevopsFeatureDisabledInFedRamp()) {
			return notFoundPageEntrypoint;
		}
		return fg('navx-global-side-nav')
			? GSNSoftwareCodeClassicPageEntrypoint
			: softwareCodeClassicPageEntrypoint;
	},
	supportsPreviewPanel: true,
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
